export function callAjax (url, data, success, error, method = 'GET') {
  const params = typeof data === 'string'
    ? data
    : Object.keys(data).map(
      k => {
        return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
      }
    ).join('&')

  const xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP')

  xhr.onload = () => {
    // Process our return data
    if (xhr.status >= 200 && xhr.status < 300) {
      // What do when the request is successful
      success(xhr.responseText)
    } else {
      // What do when the request fails
      error(xhr.statusText)
    }
    // Code that should run regardless of the request status
    // console.log('This always runs...');
  }

  xhr.open(method, url)
  // xhr.onreadystatechange = () => {
  //   if (xhr.readyState === 4 && xhr.status === 200) {
  //     // const responseText = xhr.responseText
  //     //   ? xhr.responseText
  //     //   : null
  //     success(xhr.responseText)
  //   } else {
  //     error(xhr.statusText)
  //   }
  // }

  // xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
  // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
  // xhr.setRequestHeader('Access-Control-Allow-Origin', '*')
  // xhr.AddHeader('Access-Control-Allow-Origin', '*')
  xhr.send(params)
  return xhr
}

export function postData (url, data, success, errorFn) {
  const params = typeof data === 'string'
    ? data
    : Object.keys(data).map(
      k => {
        return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
      }
    ).join('&')
  // Default options are marked with *
  return fetch(`${url}?${params}`, {
    // body: JSON.stringify(data), // must match 'Content-Type' header
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    // credentials: 'same-origin', // include, same-origin, *omit
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'GET' // *GET, POST, PUT, DELETE, etc.
    // mode: 'cors' // no-cors, cors, *same-origin
    // redirect: 'follow', // manual, *follow, error
    // referrer: 'no-referrer' // *client, no-referrer
  })
    .then(response => response.json())
    .catch(error => {
      if (errorFn) {
        errorFn(error)
      }
      console.error('Error:', error)
    })
    .then(result => {
      if (success) {
        success(result)
        // success(JSON.stringify(result, null, 2))
      }
      // console.info('Success:', result.status)
    })
}

export async function fetchContent (url, data) {
  const params = typeof data === 'string'
    ? data
    : Object.keys(data).map(
      k => {
        return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
      }
    ).join('&')

  const response = await fetch(`${url}?${params}`, {
    method: 'GET'
  })

  // the server responds with confirmation and the image size
  const result = await response.text()
  return result
}

export default callAjax

